import { Card, CardContent, CardHeader } from "@bvhi/ui-base";
import { useTranslation } from "react-i18next";
import { CatalogAccessTypeSelectField } from "../components/catalog-rules/platform-catalog-access-type-select-field";

export const CatalogsUpdateMatchingRulesAccessTypeCard = () => {
  const { t } = useTranslation(["catalogs"]);
  return (
    <Card elevation={0}>
      <CardHeader
        subheader={t("catalogs:catalogs.cards.access.type.card.sub.title")}
        title={t("catalogs:catalogs.cards.access.type.card.title")}
      />
      <CardContent>
        <CatalogAccessTypeSelectField />
      </CardContent>
    </Card>
  );
};
